<template>
  <div class="fixed inset-0 z-50 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end">
    <div class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
      <div class="p-4">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <div
              :class="[
                'w-10 h-10 rounded-full flex items-center justify-center',
                notification.type === 'success' ? 'bg-green-100' : 'bg-red-100'
              ]"
            >
              <i
                :class="[
                  'text-lg',
                  notification.type === 'success' ? 'fa-solid fa-check text-green-600' : 'fa-solid fa-exclamation-triangle text-red-600'
                ]"
              ></i>
            </div>
          </div>
          <div class="ml-3 w-0 flex-1 pt-0.5">
            <p
              :class="[
                'text-sm font-medium',
                notification.type === 'success' ? 'text-green-900' : 'text-red-900'
              ]"
            >
              {{ notification.title }}
            </p>
            <p class="mt-1 text-sm text-gray-500">
              {{ notification.message }}
            </p>
          </div>
          <div class="ml-4 flex-shrink-0 flex">
            <button
              @click="$emit('close')"
              class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            >
              <span class="sr-only">Close</span>
              <i class="fa-solid fa-times text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';

interface Notification {
  id: string;
  type: 'success' | 'error';
  title: string;
  message: string;
}

defineProps<{
  notification: Notification;
}>();

defineEmits<{
  close: [];
}>();
</script>
